export default __webpack_public_path__ + "static/media/Cuvette_rack.dc201740.svg";